function getNextWorkingDay(): Date {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day === 6) date.setDate(date.getDate() + 2); // Samstag → Montag
    if (day === 0) date.setDate(date.getDate() + 1); // Sonntag → Montag
    return date;
}

document.addEventListener('DOMContentLoaded', () => {
    flatpickr('.js-datepicker', {
        locale: flatpickr.l10ns.de,
        dateFormat: "d.m.Y",
        minDate: "today",
        defaultDate: getNextWorkingDay(),
        disableMobile: true
    })
})